import React, { Component,} from 'react';
import { observer, inject } from 'mobx-react';
import { Link } from 'react-router';
import ItemList from '../Form/ItemList';
import Spinner from '../Spinner';

@inject('inventoryItemStore', 'inventoryProductStore', 'stationStore','inventorySupplierStore')
@observer
class InventoryItem extends Component {

  componentWillMount() {
    const { inventoryProductStore, inventorySupplierStore } = this.props;
    if (!inventoryProductStore.isLoading && !inventoryProductStore.items.length) inventoryProductStore.fetchItems();
    if (!inventorySupplierStore.isLoading && !inventorySupplierStore.items.length) inventorySupplierStore.fetchItems();
  }


  render() {
    const { inventoryItemStore, inventoryProductStore, stationStore, children,inventorySupplierStore } = this.props;
    if (inventoryProductStore.isLoading || inventorySupplierStore.isLoading ) return <Spinner />;

    let items = inventoryItemStore.items.map(item => {
      let station = stationStore.findById(item.station_id);
      return Object.assign(item, {
        serial_no: item.serial_no.toString(),
        product: inventoryProductStore.findById(item.product_id),
        station: station ? <Link to={`/station/${station.id}/inventory`}>{station.name}</Link> : ''
      })
    })

    return (
      <ItemList
        store={inventoryItemStore}
        data={items}
        columns={[
          { key: 'id', label: 'ID' },
          { key: 'serial_no', label: 'Serial No', searchable: true },
          { key: 'product.name', label: 'Product', searchable: true },
          { key: 'purchase_date', label: 'Purchase Date', searchable: true },
          { key: 'warranty_date', label: 'Warranty Date', searchable: true },
          { key: 'calibration_date', label: 'Calibration Date', searchable: true },
          { key: 'station', label: 'Station', searchable: true },
          { key: 'present_location', label: 'Present Location', searchable: true },
        ]}
        slug={'inventory/item'}
        resource={'inventory'}
        children={children}
        allowAdd
        allowEdit
        allowDelete
      />
    );
  }
}

export default InventoryItem;



// WEBPACK FOOTER //
// ./src/components/Inventory/ItemList.js